import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@timeghost/ui/shadcn/button";
import type { JSX } from "react";
import TimeghostMark from "@/components/ui/timeghost-mark";

export const NotFoundPage = (): JSX.Element => (
	<div className="flex h-full flex-col items-center justify-center gap-4">
		<TimeghostMark className="size-10" />
		<h1 className="font-bold text-4xl">404</h1>
		<p className="text-lg">Page not found</p>
		<Button asChild size="sm" variant="outline">
			<Link to="/">Go to home</Link>
		</Button>
	</div>
);

export const Route = createFileRoute("/not-found/")({
	component: NotFoundPage,
});
